import { Facebook, Instagram, MessageCircleMore, } from "lucide-react";

const Footer = () => {
  return (
    <footer className="border-t border-neutral-800 bg-[#0d1117] text-neutral-300 py-5 px-6 relative overflow-hidden mt-auto">
      <div className="rounded-full blur-3xl z-0" />
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-10 relative z-10">
        <div>
          <h3 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-blue-400 text-transparent bg-clip-text mb-4">
            DevParts
          </h3>
          <p className="text-sm text-neutral-400 leading-relaxed">
            Creamos soluciones digitales como si fueran piezas de un
            rompecabezas. Hechas a medida, encajan perfecto en tus necesidades.
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold text-lg mb-3">Enlaces</h4>
          <ul className="space-y-2 text-sm">
            {["Inicio", "Servicios", "Proyectos", "Contacto"].map((item, i) => (
              <li key={i}>
                <a
                  href={`#${item.toLowerCase()}`}
                  className="hover:text-blue-400 transition duration-300"
                >
                  {item}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold text-lg mb-3">Síguenos</h4>
          <p className="text-sm text-neutral-400 mb-4">
            Conecta con nosotros en nuestras redes o escríbenos directamente.
          </p>
          <div className="flex gap-4">
            {
            [
              {
                icon: <Facebook size={20} />,
                href: "https://www.facebook.com/profile.php?id=61575327265196",
                target: "_blank",
              },
              {
                icon: <Instagram size={20}/>,
                href: "https://www.instagram.com/dev_parts/?utm_source=ig_web_button_share_sheet",
                target: "_blank",
              },
              {
                icon: <MessageCircleMore size={20} />,
                href: "https://wa.link/zid2kt",
                target: "_blank",
              },
            ].map((item, i) => (
              <a
                key={i}
                href={item.href}
                target={item.target}
                className="bg-neutral-800 hover:bg-blue-600 hover:text-white transition-colors duration-300 p-2 rounded-full"
              >
                {item.icon}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Línea inferior */}
      <div className="pt-5 text-center text-sm text-neutral-500">
        © {new Date().getFullYear()} DevParts. Todos los derechos reservados.
      </div>
    </footer>
  );
};

export default Footer;
